import { jsxs as t, jsx as s } from "react/jsx-runtime";
import { c as u } from "../../../../clsx-OuTLNxxd.js";
import { s as l, C as v } from "../../../../counterInput-DPQQGknO.js";
const C = ({
  label: a,
  onChange: d,
  errorMessage: e,
  helperText: c,
  inputInitialValue: n,
  maxValue: m,
  minValue: o,
  hasError: i,
  disabled: r,
  placeholderForZero: p,
  isFullWidth: f = !1
}) => /* @__PURE__ */ t("div", { className: u(l["group-container"], f && l["full-width"]), children: [
  /* @__PURE__ */ t("div", { className: l.label, children: [
    /* @__PURE__ */ s("div", { children: a }),
    !i && c && /* @__PURE__ */ s("div", { className: l["helper-text"], children: c }),
    i && e && /* @__PURE__ */ s("div", { className: l.error, children: e })
  ] }),
  /* @__PURE__ */ s(
    v,
    {
      inputInitialValue: n,
      minValue: o,
      maxValue: m,
      hasError: i,
      disabled: r,
      onChange: d,
      placeholderForZero: p
    }
  )
] });
export {
  C as Counter
};
